// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"cab9d675","796":"4f5cdb14"}[chunkId] + ".chunk.js";
};